var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "results-list-pagination" } }, [
    _vm.paginationArray.length > 1
      ? _c(
          "nav",
          { attrs: { id: "list-pagination" } },
          [
            _c(
              "button",
              {
                staticClass: "arrow-button",
                class: _vm.paginationPosition === 0 ? "disabled" : "",
                attrs: { type: "button" },
                on: { click: _vm.previousPage },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("chevron_left"),
                ]),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.paginationArray, function (page) {
              return [
                page
                  ? _c(
                      "button",
                      {
                        class:
                          _vm.paginationPosition === page - 1 ? "active" : "",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.gotoPage(page)
                          },
                        },
                      },
                      [
                        _c("span", { staticClass: "pagination-number" }, [
                          _vm._v(_vm._s(page)),
                        ]),
                      ]
                    )
                  : _c("span", { staticClass: "ellipsis-span" }, [_vm._v("…")]),
              ]
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "arrow-button",
                class:
                  _vm.paginationPosition === _vm.paginationPages - 1
                    ? "disabled"
                    : "",
                attrs: { type: "button" },
                on: { click: _vm.nextPage },
              },
              [
                _c("span", { staticClass: "material-icons" }, [
                  _vm._v("chevron_right"),
                ]),
              ]
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "pagination-results-per-page" } }, [
      _c(
        "button",
        {
          staticClass: "compact",
          class: _vm.paginationResultsPerPageVisible ? "active" : "",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              $event.preventDefault()
              $event.stopPropagation()
              _vm.paginationResultsPerPageVisible =
                !_vm.paginationResultsPerPageVisible
            },
          },
        },
        [
          _vm._v(
            "\n      " +
              _vm._s(
                _vm.t("app-pagination-results-per-page", {
                  count: _vm.paginationResultsPerPage,
                })
              ) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.paginationResultsPerPageVisible,
              expression: "paginationResultsPerPageVisible",
            },
          ],
          staticClass: "pagination-results-per-page-list",
        },
        _vm._l(_vm.paginationResultsPerPageOptions, function (option, i) {
          return _c(
            "div",
            { staticClass: "pagination-results-per-page-option" },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.paginationResultsPerPage,
                    expression: "paginationResultsPerPage",
                  },
                ],
                attrs: {
                  type: "radio",
                  required: "required",
                  id: `pagination-results-per-page-option-${option}`,
                  name: "pagination-results-per-page-options",
                },
                domProps: {
                  checked: _vm.paginationResultsPerPage === option,
                  value: option,
                  checked: _vm._q(_vm.paginationResultsPerPage, option),
                },
                on: {
                  change: function ($event) {
                    _vm.paginationResultsPerPage = option
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                {
                  attrs: {
                    for: `pagination-results-per-page-option-${option}`,
                  },
                },
                [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.t("app-pagination-results-per-page", {
                          count: option,
                        })
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "pagination-results-range" } }, [
      _vm._v(
        "\n    " +
          _vm._s(
            _vm.t("app-pagination-results-range", {
              start: _vm.paginationRangeStart,
              end: _vm.paginationRangeEnd,
              total: _vm.paginationTotal,
            })
          ) +
          "\n  "
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }